<template>
  <div>
    <div v-if="loading" class="d-flex justify-content-center mt-3">
      <div>
        <div class="spinner-border position-absolute spinner-class"></div>
      </div>
      <div :style="{ 'margin-left': '-14px', 'margin-top': '40px', marginBottom: '100%' }">
        Loading...
      </div>
    </div>
    <Article v-if="componentRenderStatus.article" :articleData="data"></Article>
    <Quiz v-if="componentRenderStatus.quiz" :quizData="data"></Quiz>
    <Video v-if="componentRenderStatus.video" :videoData="data"></Video>
    <Poll v-if="componentRenderStatus.poll" :pollData="data"></Poll>
    <Trivia v-if="componentRenderStatus.trivia" :pollData="data" />
    <Slideshow
      v-if="componentRenderStatus.slideshow"
      :videoData="data"
    ></Slideshow>
  </div>
</template>

<script>
import Article from "./contents/Article";
import Quiz from "../quiz/Quiz";
import Video from "./contents/Video";
import Slideshow from "./contents/Slideshow";
import Poll from "./contents/Poll";
import Trivia from "./contents/Trivia";

import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
import { eventBus } from "../../../main";

const ResourceRepository = RepositoryFactory.get("resource");

export default {
  name: "ResourceView",
  data() {
    return {
      type: null,
      id: null,
      data: null,
      componentRenderStatus: {
        article: false,
        quiz: false,
        poll: false,
        slideshow: false,
        video: false,
        trivia: false
      },
      loading: true
    };
  },
  components: {
    Article,
    Quiz,
    Video,
    Slideshow,
    Poll,
    Trivia
  },

  created() {
    this.type = this.$route.params.type;
    this.id = this.$route.params.id;
    this.fetchResource();
    eventBus.$on("refresh-resource-view", () => {
      this.fetchResource();
    });
  },

  methods: {
    fetchResource() {
      this.loading = true;
      this.getResourceFunction()
        .then(res => {
          if (this.type === "video") {
            this.data = res.data.data.length ? res.data.data[0] : null;
          } else if (this.type === "slideshow") {
            this.data = res.data.data.length ? res.data.data[0] : null;
          } else {
            this.data = res.data.data.data.length
              ? res.data.data.data[0]
              : null;
          }

          this.componentRenderStatus[this.type] = true;
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },

    getResourceFunction() {
      switch (this.type) {
        case "article":
          return ResourceRepository.getarticle(this.id);

        case "quiz":
          return ResourceRepository.getquiz(this.id);
        case "poll":
          return ResourceRepository.getpoll(
            this.id,
            1,
            5,
            this.currentCircle.id
          );
        case "video":
          return ResourceRepository.getvideo(this.id);
        case "trivia":
          return ResourceRepository.getpoll(
            this.id,
            1,
            5,
            this.currentCircle.id
          );
        case "slideshow":
          return ResourceRepository.getslideshow(this.id, this.currentCircle.id);
        default:
          break;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/home/resources/ResourceView.vue